/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import Chevron from '../Icons/Chevron';
import CheckIcon from '../Icons/CheckIcon';
import { XIcon } from 'lucide-react';
interface ComboBoxProps {
    bankQuestions: { id: string; name: string }[];
    selectedBankQuestions: { id: string; name: string }[];
    setSelectedBankQuestions: React.Dispatch<React.SetStateAction<{ id: string; name: string }[]>>;
}

const ComboBox: React.FC<ComboBoxProps> = ({ bankQuestions, selectedBankQuestions, setSelectedBankQuestions }) => {
    const [query, setQuery] = useState('');

    // Filter out already selected questions and apply the search query
    const filteredPeople =
        query === ''
            ? bankQuestions.filter((person) => !selectedBankQuestions.some((selected) => selected.id === person.id))
            : bankQuestions.filter((person) =>
                person.name
                    .toLowerCase()
                    .replace(/\s+/g, '')
                    .includes(query.toLowerCase().replace(/\s+/g, '')) &&
                !selectedBankQuestions.some((selected) => selected.id === person.id)
            );

    // Function to handle removing a question
    const removeQuestion = (id: string) => {
        setSelectedBankQuestions(prev => prev.filter(question => question.id !== id));
    };

    return (
        <div className="relative mt-1">
            <Combobox
                value={selectedBankQuestions}
                onChange={setSelectedBankQuestions}
                //@ts-expect-error
                multiple
            >
                <div className="border-2 border-black border-opacity-40 block w-full p-4 focus:outline-none hover:border-primary hover:border-opacity-100 transition-all ease-in focus:border-secondary focus:ring-secondary/50 bg-[#F5F6F8]  border-black/15 !rounded mb-10">
                    <Combobox.Button className="justify-between h-auto flex items-start pr-2 w-full">
                        <Combobox.Input
                            className="w-full border-none bg-transparent focus:outline-none pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                            onChange={(event) => setQuery(event.target.value)}
                        />
                        <Chevron className="h-5 w-5 text-gray-400" />
                    </Combobox.Button>
                </div>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    afterLeave={() => setQuery('')}
                >
                    <Combobox.Options className="absolute mt-1 top-10 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-50">
                        {filteredPeople.length === 0 && query !== '' ? (
                            <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                Nothing found.
                            </div>
                        ) : (
                            filteredPeople.map((person) => (
                                <Combobox.Option
                                    key={person.id}
                                    className={({ active }) =>
                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-primary/20 text-black' : 'text-gray-900'
                                        }`
                                    }
                                    value={person}
                                >
                                    {({ active }) => (
                                        <>
                                            <span
                                                className={`block truncate ${active ? 'font-medium' : 'font-normal'
                                                    }`}
                                            >
                                                {person.name}
                                            </span>
                                            {selectedBankQuestions.some((selected) => selected.id === person.id) && (
                                                <span
                                                    className={`absolute inset-y-0 left-0 flex items-center pl-3 text-primary`}
                                                >
                                                    <CheckIcon />
                                                </span>
                                            )}
                                        </>
                                    )}
                                </Combobox.Option>
                            ))
                        )}
                    </Combobox.Options>
                </Transition>
            </Combobox>
            <div className="mb-2">
                {selectedBankQuestions.map((person) => (
                    <div key={person.id} className="bg-blue-100 inline-block text-blue-700 rounded-full px-3 py-1 text-sm font-semibold mr-2 mb-2  items-center">
                        <div className='flex items-center'>
                        {person.name}
                        <button
                            type="button"
                            className="ml-2 text-blue-700 hover:text-blue-900"
                            onClick={() => removeQuestion(person.id)}
                        >
                            <XIcon className="w-4 h-4" /> {/* Assume you have an XIcon component */}
                        </button>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ComboBox;
